const CONFIGS_FAVORITOS = {};

export default CONFIGS_FAVORITOS;
